import React, { FC } from "react";
import { batch, useDispatch } from "react-redux";
import { ICarSetSearchProps } from "../../../interfaces/ICar";
import { openTransfersModal } from "../../../store/actions/transferActions";

type Props = ICarSetSearchProps & {
  className?: string;
  disabled?: boolean;
};

const TransferButton: FC<Props> = ({ className, disabled, children }) => {
  const dispatch = useDispatch();

  const clickHandler = () => {
    batch(() => {
      dispatch(openTransfersModal());
    });
  };
  return (
    <button className={`x-sell-button ${className}`} disabled={disabled} onClick={clickHandler}>
      {children}
    </button>
  );
};

export default TransferButton;
